module.exports = new __parcel__URL__("404.63367b3b.svg").toString();